module.exports = __webpack_public_path__ + "static/media/non-active-row.9d1fbaa2.svg";